import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import SportsListPanelImpl from './sports-list-panel.js';

const { UIView } = MojitoCore.Presentation;

/**
 * Lists the available sports as an accordion, each expanding into the top and all competitions
 * of that sport. Rendered inside the search discovery overlay.
 *
 * @class SportsListPanel
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * `SportsListPanel` prop types.
 *
 * @property {Array<object>} sports - Sports to list, as delivered by the sports content service.
 * @property {Function} [onNavigate] - Called after the user triggers navigation from within the panel.
 *
 * @memberof Mojito.Applications.Sports.Search.SportsListPanel
 */
const propTypes = {
    sports: PropTypes.arrayOf(PropTypes.object).isRequired,
    onNavigate: PropTypes.func,
};

const defaultProps = {
    onNavigate: noop,
};

export default UIView('SportsListPanel', SportsListPanelImpl, propTypes, defaultProps);
